import DashboardIcon from "@mui/icons-material/Dashboard";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CandlestickChartIcon from "@mui/icons-material/CandlestickChart";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import InsightsIcon from "@mui/icons-material/Insights";
import SummarizeIcon from "@mui/icons-material/Summarize";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import SettingsIcon from "@mui/icons-material/Settings";
import DnsIcon from "@mui/icons-material/Dns";
import type { SvgIconComponent } from "@mui/icons-material";

export interface NavItem {
  label: string;
  path: string;
  icon: SvgIconComponent;
}

export const navItems: NavItem[] = [
  { label: "Dashboard", path: "/dashboard", icon: DashboardIcon },
  { label: "Portfolio", path: "/portfolio", icon: AccountBalanceWalletIcon },
  { label: "Trading", path: "/trading", icon: CandlestickChartIcon },
  { label: "Orders", path: "/orders", icon: ReceiptLongIcon },
  { label: "Trades", path: "/trades", icon: SwapHorizIcon },
  { label: "Analytics", path: "/analytics", icon: InsightsIcon },
  { label: "Reports", path: "/reports", icon: SummarizeIcon },
  { label: "Broker", path: "/broker", icon: AccountTreeIcon },
  { label: "System", path: "/system", icon: DnsIcon },
  { label: "Settings", path: "/settings", icon: SettingsIcon },
];
